import Endpoints from 'constants/Endpoints';
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'
import isResponseValid from "../libs/isResponseValid";
import OfferChoiceService from "./OfferChoiceService";
import validateSection from "./helpers/validateSection";
import {DemandValidation} from "../constants/DemandValidation";

const ADDITIONAL_PASSIVE_ROUNDS_LIST_RESOURCE_ID = 'additionalPassiveRoundsList';

const getAdditionalPassiveRoundsList = async (demandId) => {
    const resp = await RestRequestGET(Endpoints.ADDITIONAL_ROUNDS_PASSIVE(demandId));
    if (resp.success)
        reduxStore.dispatch(setResource(ADDITIONAL_PASSIVE_ROUNDS_LIST_RESOURCE_ID, resp.result));
    else
        throw new Error(resp.errors);
};

const updateAdditionalPassiveRound = async (demandId, roundId, sectionsToRefresh) => {
    const resp = await RestRequestGET(Endpoints.ADDITIONAL_ROUNDS_PASSIVE_ROUND(demandId, roundId));
    if (resp.success) {
        const {resources} = reduxStore.getState();
        const list = resources[ADDITIONAL_PASSIVE_ROUNDS_LIST_RESOURCE_ID].map(x => x.roundId === resp.result.roundId ? resp.result : x);
        reduxStore.dispatch(setResource(ADDITIONAL_PASSIVE_ROUNDS_LIST_RESOURCE_ID, list));
        await validateSection(DemandValidation.ADDITIONAL_ROUND_PASSIVE, demandId, false);
        await OfferChoiceService.callSectionsValidation(demandId, sectionsToRefresh)
    } else
        throw new Error(resp.errors);
};

const getAvailableContractors = async (demandId, setError) => {
    const res = await RestRequestGET(Endpoints.ADDITIONAL_ROUNDS_PASSIVE_AVAILABLE_CONTRACTORS(demandId));
    if (isResponseValid(res, setError))
        return res.result;
};


const createAdditionalPassiveRound = async (demandId, values) => {

    const data = {
        departmentIds: Object.keys(values.contractors).filter(x => values.contractors[x] === true).map(x => x.substring(1)),
        endDate: values.endDate.format(),
        openOfferDate: values.openOfferDate.format()
    }

    const resp = await RestRequestPOST(Endpoints.ADDITIONAL_ROUNDS_PASSIVE(demandId), data);
    const {resources} = reduxStore.getState();
    if (resp.success)
        reduxStore.dispatch(setResource(ADDITIONAL_PASSIVE_ROUNDS_LIST_RESOURCE_ID, [resp.result, ...resources[ADDITIONAL_PASSIVE_ROUNDS_LIST_RESOURCE_ID]]));
    else
        throw new Error(resp.errors);
}


const validate = async (id) => {
    return RestRequestGET(Endpoints.ADDITIONAL_ROUNDS_PASSIVE_VALIDATE(id));
}

const clearResources = (resource) => {
    reduxStore.dispatch(clearResource(resource));
};

export default {
    getAdditionalPassiveRoundsList,
    updateAdditionalPassiveRound,
    getAvailableContractors,
    createAdditionalPassiveRound,
    validate,
    clearResources,
    ADDITIONAL_PASSIVE_ROUNDS_LIST_RESOURCE_ID
}